var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSelect',_vm._b({attrs:{"label":_vm.label,"required":_vm.required},on:{"input":function($event){return _vm.$emit('input', $event)}}},'FormSelect',_vm.$attrs,false),_vm._l((_vm.usaStates),function(state){return _c('option',{key:state,domProps:{"value":state}},[_vm._v(_vm._s(state))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }